<h4>
  {{ 'profiles.view.affiliations.label' | translate | titlecase }}&nbsp;&nbsp;<span class="card-field-label">({{ affCount }})</span>
</h4>
<div *ngFor="let type of affiliations" class="aff-code-type-container">
  <div class="card-field-label">
    {{ type.AffCodeType != '' ? type.AffCodeType : ('profiles.view.affiliations.no-aff-type' | translate | titlecase) }}
  </div>
  <div class="aff-code-container mct-flex mct-row mct-wrap" >
    <div class="mct-flex aff-code mct-justify-around mct-items-center" *ngFor="let code of type.AffPros" >{{ code }}</div>
  </div>
</div>
